import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

/**
 * 画面タイトル表示
 * @param  {string} {pageTitle}
 * @return {object}
 */
function PageTitleInformation({pageTitle}) {
  return (
    <React.Fragment>
      <Box component="div" sx={{'marginTop': '16px'}}>
        <Typography variant="h6">
          <Box component="span"
            sx={{
              borderBottom: 'solid 1px gray',
              color: '#000',
              background: '#fff',
              fontWeight: 'bold'}}>
            {pageTitle}
          </Box>
        </Typography>
      </Box>
    </React.Fragment>
  );
};

PageTitleInformation.propTypes = {
  pageTitle: PropTypes.string,
};

export default PageTitleInformation;
